import React from 'react';

const Vue_VBind = () => {
  return (
    <div>
      <h1>Vue_VBind Component</h1>
      <p>This is the Vue_VBind tutorial page.</p>
    </div>
  );
}

export default Vue_VBind;
